var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsageAcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8745 12.375L14.4933 17.7562C14.2154 18.0352 13.8852 18.2565 13.5216 18.4075C13.1581 18.5585 12.7682 18.6363 12.3745 18.6363C11.9808 18.6363 11.591 18.5585 11.2274 18.4075C10.8638 18.2565 10.5336 18.0352 10.2558 17.7562L6.24328 13.7438C5.96436 13.4659 5.74304 13.1357 5.59203 12.7721C5.44102 12.4085 5.36328 12.0187 5.36328 11.625C5.36328 11.2313 5.44102 10.8415 5.59203 10.4779C5.74304 10.1143 5.96436 9.7841 6.24328 9.50625L11.6245 4.125",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.75L3 21",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6L17.25 2.25",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 6.75L18 10.5",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5L10.5 3",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageAcIcon);
export default __webpack_public_path__ + "static/media/UsageAcIcon.2ef7ee16ba86564b581ad31a1d16461d.svg";
export { ForwardRef as ReactComponent };